/* eslint-disable */
export default {
    profile_highest_advanced_education_level: "Welches ist Ihr höchstes Bildungsniveau in der Hochschul- oder Berufsausbildung?",
    profile_highest_basic_education_level: "Welches ist Ihr höchstes Bildungsniveau im Sekundarbereich?",
    profile_date_of_birth: "Geburtsdatum",
    profile_gender: "Geschlecht",
    profile_unexpected_error: "Es ist ein Fehler aufgetreten. Versuchen Sie es erneut.",
    profile_check_your_details_intro: "Kontrollieren Sie Ihre Angaben und ändern Sie diese, falls nötig.",
    profile_check_your_details_title: "Ihre persönlichen Angaben",
    profile_check_your_details_save: "Speichern & fortfahren",
    profile_update_personal_data_error: "Beim Aktualisieren der persönlichen Daten ist ein Fehler aufgetreten. Versuchen Sie es später nochmals.",
    profile_update_details_could_not_fetch_form_fields: "Es ist etwas schief gelaufen beim Abrufen des Formulars mit der ID:",
    profile_feature_toggles_page_title: "Umschaltbare Funktionen",
    profile_update_details_success: "Das Profil wurde erfolgreich aktualisiert",
    profile_cv_section_modal_title: "Datei entfernen",
    profile_cv_section_modal_body: "Wollen Sie diese Datei wirklich entfernen?",
    profile_cv_section_modal_cancel: "Annullieren",
    profile_cv_section_modal_confirm: "Entfernen",
    profile_cv_section_title: "Lebenslauf hochladen",
    profile_cv_section_body: "Bitte laden Sie Ihren Lebenslauf hoch. Der Lebenslauf dient als Grundlage für das Gespräch mit Ihrem LTP-Berater, falls dies für Sie zutrifft.",
    profile_education_title: "Ausbildung",
    profile_cv_section_delete_error: "Beim Löschen der Datei ist ein Fehler aufgetreten, bitte versuchen Sie es später noch einmal.",
    profile_cv_section_delete_success: "Die Datei wurde erfolgreich entfernt.",
    profile_cv_section_upload_error: "Datei konnte nicht hochgeladen werden, bitte versuchen Sie es später nochmals.",
    profile_cv_section_download_error: "Datei konnte nicht heruntergeladen werden, bitte versuchen Sie es später nochmals.",
    profile_general_error: "Etwas ist schief gelaufen. Versuchen Sie es später nochmals.",
    profile_update_details_failed: "Beim Speichern der Daten ist ein Fehler aufgetreten.",
    profile_cv_section_upload_too_large: "Die Datei ist größer als das maximal zulässige Maximum von 5 MB.",
    profile_date_of_birth_question: "Was ist Ihr Geburtsdatum?",
    profile_amend_details_submit_button: "Zum Programm",
    profile_date_of_birth_invalid_format: "The format must be DD-MM-YYYY",
    profile_education_level_option_none: "None",
    profile_education_level_option_primary_education: "Primary education",
    profile_education_level_option_high_school: "High school",
    profile_education_level_option_vocational: "Vocational school",
    profile_education_level_option_college: "College",
    profile_education_level_option_university: "University",
    profile_education_level_option_phd: "PhD",
    profile_education_level_option_geen: "Geen",
    profile_education_level_option_havo: "Havo",
    profile_education_level_option_mavo_vmbo: "Mavo/vmbo",
    profile_education_level_option_praktijkonderwijs: "Praktijkonderwijs",
    profile_education_level_option_vwo: "Vwo",
    profile_education_level_option_hbo: "HBO",
    profile_education_level_option_mbo1: "MBO 1",
    profile_education_level_option_mbo2: "MBO 2",
    profile_education_level_option_mbo3: "MBO 3",
    profile_education_level_option_mbo4: "MBO 4",
    profile_education_level_option_bachelor: "WO bachelor",
    profile_education_level_option_master: "WO master",
    profile_select_active_competencies_label: "Which competencies would you like to measure? (min. 1)",
    profile_education_level_option_other: "Andere",
    profile_language_fluency_level: "Bitte geben Sie an, wie gut Sie folgende Sprachen beherrschen:",
    profile_language_fluency_level_primary: "Muttersprache / zweisprachige Sprachkenntnisse",
    profile_language_fluency_level_full_professional: "Fließend",
    profile_language_fluency_level_professional_working: "Gute Sprachkenntnisse",
    profile_language_fluency_level_limited_working: "Begrenzte Sprachkenntnisse",
    profile_language_fluency_level_elementary: "Grundkenntnisse",
    profile_Language_fluency_level_limited_proficiency: "Begrenzte Sprachkenntnisse",
    profile_Language_fluency_level_proficient: "Gute Sprachkenntnisse",
    profile_Language_fluency_level_fluent: "Fliessend",
    profile_Language_fluency_level_secondary: "Zweisprachig oder mehrsprachig mit Deutsch als zweiter Sprache",
    profile_Language_fluency_level_native: "Muttersprache, Deutsch als erste Sprache",
    profile_amend_details_submit_without_cv_button: "Weiter ohne Lebenslauf"
};
